import AccountCreation from "@/components/signup/account-creation";
import { UserContextProvider } from "@/components/user-context";

const UniformSignUpForm = () => {
    return (
        <UserContextProvider>
            <AccountCreation Login={null} />
        </UserContextProvider>
    );
};

export default UniformSignUpForm;
